import React from 'react';
import SearchPanel from './SearchPanel';
import './styles.css';

interface TopLeftPanelProps {
  graphData?: { nodes: any[]; edges: any[] };
  lfRef?: React.MutableRefObject<any>;
  onSaveViewState?: () => void;
  onRestoreViewState?: () => void;
  onResetView?: () => void;
}

const TopLeftPanel: React.FC<TopLeftPanelProps> = ({
  graphData = { nodes: [], edges: [] },
  lfRef,
  onSaveViewState,
  onRestoreViewState,
  onResetView
}) => {
  return (
    <div className="top-left-panel">
      <div className="top-left-panel-content">
        {lfRef && (
          <SearchPanel
            graphData={graphData}
            lfRef={lfRef}
            onSaveViewState={onSaveViewState}
            onRestoreViewState={onRestoreViewState}
            onResetView={onResetView}
          />
        )}
      </div>
    </div>
  );
};

export default TopLeftPanel;